/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OpenDeliveriesRequest
 */
export interface OpenDeliveriesRequest {
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof OpenDeliveriesRequest
     */
    deliveriesToOpen: { [key: string]: Array<string>; };
}

/**
 * Check if a given object implements the OpenDeliveriesRequest interface.
 */
export function instanceOfOpenDeliveriesRequest(value: object): value is OpenDeliveriesRequest {
    if (!('deliveriesToOpen' in value) || value['deliveriesToOpen'] === undefined) return false;
    return true;
}

export function OpenDeliveriesRequestFromJSON(json: any): OpenDeliveriesRequest {
    return OpenDeliveriesRequestFromJSONTyped(json, false);
}

export function OpenDeliveriesRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OpenDeliveriesRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'deliveriesToOpen': json['deliveriesToOpen'],
    };
}

export function OpenDeliveriesRequestToJSON(json: any): OpenDeliveriesRequest {
    return OpenDeliveriesRequestToJSONTyped(json, false);
}

export function OpenDeliveriesRequestToJSONTyped(value?: OpenDeliveriesRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deliveriesToOpen': value['deliveriesToOpen'],
    };
}

